import { Injectable } from '@angular/core';

import { StorageInterface } from './storage.interface';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    protected sessionStorageKeys: string[] = [
        'blockedPlans',
        'promoConfigurator',
        'sales_products',
        'catalog_without_tax',
        'number_callback',
    ];
    protected localStorageKeys: string[] = [];
    protected prefix: string = '';
    public KEY: { [index: string]: string } = {};

    /**
     * Use item of StorageInterface insterad of simple key value to make storage expires
     * @param key
     * @param value
     * @param expires timestamp
     */
    public setItem(key: string, value: any, expires: number = null) {
        const storageObject: StorageInterface = {
            data: value,
            expiresTimestamp: expires,
        };
        this.removeItem(key);
        this._getStorageInstance(key).setItem(this.prefix + key, JSON.stringify(storageObject));
    }

    /**
     * Return item from storage
     * If expiresTimestamp is not null and lower then Now remove item and returns null
     * @param key
     * @returns
     */
    public getItem(key: string, deleteExpires: boolean = true): any {
        let item: any = null;
        const data: string = this._getStorageInstance(key).getItem(this.prefix + key);

        if (data !== null && data !== 'undefined') {
            const storageObject: StorageInterface = JSON.parse(data);
            if (storageObject.expiresTimestamp || storageObject.expiresTimestamp != null) {
                if (storageObject.expiresTimestamp < new Date().getTime()) {
                    if (deleteExpires) {
                        this.removeItem(key);
                    } else {
                        item = storageObject.data;
                        item.expires = true;
                    }
                } else {
                    item = storageObject.data || storageObject;
                }
            } else {
                item = storageObject.data || storageObject;
            }
        }
        return item;
    }

    public removeItem(key: string) {
        this._getStorageInstance(key).removeItem(this.prefix + key);
    }

    /**
     *
     * @param storageInstance
     */
    public clear(storageInstance?: Storage) {
        if (storageInstance instanceof Storage) {
            this.clearAllPrefix(storageInstance);
        } else {
            this.clearAllPrefix(sessionStorage);
            this.clearAllPrefix(localStorage);
        }
    }

    /**
     *
     * @param key
     * @returns
     * @private
     */
    protected _getStorageInstance(key: string): Storage {
        let storage: Storage;
        if (this.sessionStorageKeys.includes(key)) {
            storage = sessionStorage;
        } else if (this.localStorageKeys.includes(key)) {
            storage = localStorage;
        } else {
            storage = localStorage;
        }
        return storage;
    }

    private clearAllPrefix(storageInstance: Storage) {
        const keys: string[] = Object.keys(storageInstance);
        for (const key of keys) {
            if (key.startsWith(this.prefix)) {
                storageInstance.removeItem(key);
            }
        }
    }
}
